/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    InvoiceItem,
    InvoiceItemFromJSON,
    InvoiceItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface Invoices
 */
export interface Invoices {
    /**
     * Cursor to fetch next set of results.
     * @type {string}
     * @memberof Invoices
     */
    cursor?: string;
    /**
     * 
     * @type {Array<InvoiceItem>}
     * @memberof Invoices
     */
    results: Array<InvoiceItem>;
}

export function InvoicesFromJSON(json: any): Invoices {
    return {
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        
        'results': (json['results'] as Array<any>).map(InvoiceItemFromJSON),
        
    };
}

export function InvoicesToJSON(value?: Invoices): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cursor': value.cursor,
        
        'results': (value.results as Array<any>).map(InvoiceItemToJSON),
        
    };
}


